import * as z from "zod/v4";

const GetSourcesByDomainInput_ = z.object({ limit: z.number().nullish() });

const DomainCount_ = z.object({ domain: z.string(), count: z.number() });

export const getSourcesByDomain = {
  name: "getSourcesByDomain" as const,
  input: GetSourcesByDomainInput_,
  output: z.object({ domains: z.array(DomainCount_) }),
};
